import React, { Component } from 'react';

class PageBreak extends Component {
    render() {
        return (
            <div className="html2pdf__page-break"></div> 
        );
    }
}

export default PageBreak;
